import styled from 'styled-components';

interface ContentsProps {
  length: number;
}

export const Container = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 1px;
`;

export const Contents = styled.div<ContentsProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px 0;
  width: 100%;
  height: ${({ length }) => length * 100}%;
  position: relative;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.grayscale700};
`;

export const Title = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.palette.grayscale300};
  ${({ theme }) => theme.typography('$caption_01', 500)};
`;
